import { IRootState } from '../../../store'
import { IDrainOptionsState } from '../store/options.types'

export const getDrainOptionsSelector = (state: IRootState): IDrainOptionsState => state.options.drainOptions
